const COLORS = {
  cnda: "#4a919e",
  dreihaus: "#ce6a6b",
}

export default COLORS
